//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from '../utils/create';
import { props } from './props';
import { useLockScroll } from '../utils/lock-scroll';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.visible ? _c('div', {
    staticClass: "cb-dialog",
    on: {
      "click": function ($event) {
        return _vm.handleClickModalClose($event);
      }
    }
  }, [_c('transition', {
    attrs: {
      "enter-active-class": _vm.animateEnter,
      "leave-active-class": _vm.animateLeave,
      "name": "custom-transition"
    },
    on: {
      "after-leave": _vm.handleAnimateAfterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.containerVisible,
      expression: "containerVisible"
    }],
    ref: "cb-dialog__container",
    staticClass: "cb-dialog__container animate__animated",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("default"), _vm._v(" "), _vm.showClose ? _c('div', {
    staticClass: "cb-dialog__close",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.handleClickIconClose.apply(null, arguments);
      }
    }
  }) : _vm._e()], 2)])], 1) : _vm._e();
};
var staticRenderFns = [];
export default defineComponent({
  _scopeId: 'data-v-22f7759c',
  render,
  name: 'CbDialog',
  props,
  data() {
    return {
      unlock: null,
      // 用于动画
      containerVisible: false,
      // icon, modal
      closeType: 'icon'
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.lockScroll();
        } else {
          typeof this.unlock === 'function' && this.unlock();
        }
        setTimeout(() => {
          this.containerVisible = this.visible;
        }, 0);
      }
    }
  },
  mounted() {
    if (this.appendToBody) {
      document.body.appendChild(this.$el);
    }
  },
  destroyed() {
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  methods: {
    lockScroll() {
      this.$nextTick(() => {
        this.unlock = useLockScroll(this.$refs['cb-dialog__container']);
      });
    },
    handleClickIconClose() {
      this.closeType = 'icon';
      if (this.animateLeave) {
        this.containerVisible = false;
      } else {
        this.handleClose();
      }
    },
    handleClickModalClose(e) {
      e.stopPropagation();
      if (!this.closeOnClickModal) {
        return;
      }
      this.closeType = 'modal';
      if (this.animateLeave) {
        this.containerVisible = false;
      } else {
        this.handleClose();
      }
    },
    handleAnimateAfterLeave() {
      this.handleClose();
    },
    handleClose() {
      this.$emit('update:visible', false);
      if (this.closeType === 'icon') {
        this.$emit('icon-close');
      } else if (this.closeType === 'modal') {
        this.$emit('close');
      }
    }
  },
  beforeDestroy() {
    typeof this.unlock === 'function' && this.unlock();
  }
});